import CameraList from "./CameraList";
import CamWebView from "./CamWebView";
import CameraDevices from "./CameraDevices";
import { CAMERA_PATHS } from "./paths";

export { CAMERA_PATHS, CameraDevices };

// Camera pages behind the Camera tab (pages/Home/Camera.js) and the Devices
// tab's CAMERAS chip, as the app's CameraList and CamWebView screens.
export const CAMERA_ROUTES = [
  { path: CAMERA_PATHS.DEVICE, component: CameraList },
  { path: CAMERA_PATHS.VIEW, component: CamWebView },
];
